import { Component, OnInit, QueryList, ViewChildren } from "@angular/core";
import { FormGroup, FormBuilder, FormControl, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UserService, AuthenticationService } from "app/auth/service";
import { ListService } from "app/auth/service/list.service";
import { UserFigureService } from "app/auth/service/user-figure.service";
import { UtilsService } from "app/auth/service/utils.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { DatepickrComponent } from "app/layout/components/datepickr/datepickr.component";
import { ProductsService } from "app/modules/products/products.service";
import moment from "moment";
import { locale as italian } from "app/i18n/it";
import { DeviceDetectorService } from "ngx-device-detector";
import { ToastrService } from "ngx-toastr";
import { ProductDealsService } from "app/modules/products/products-deals.service";
import { IColumnTable, IDealProductForm, IDealProductSingle, ITableRows } from "app/modules/products/models/products-deals";
import { IProductList } from "app/modules/products/models/products";
import { IFigure } from "app/auth/models/figures";
import { ICustomer, ICustomerAddressList, ICustomerReferentList } from "../../../../customer/customer.interface";
import { CustomerService } from "../../../../customer/customer.service";

@Component({
  selector: "app-product-deals-edit",
  templateUrl: "./product-deals-edit.component.html",
  styleUrls: ["./product-deals-edit.component.scss"],
})
export class ProductDealsEditComponent implements OnInit {
  @ViewChildren(DatepickrComponent) datePicker: QueryList<DatepickrComponent>; //Prendiamo cosi tutti gli input date per eseguire il reset
  public contentHeader: IContentHeader;
  public activeTab: string = "deal_detail";
  public productsList: IProductList[] = [];
  public deal: IDealProductSingle = null;
  public dealId: number = null;
  public isDetailSectionCompleted: boolean = true;
  public isThereDiscount: boolean = false; //True if there is a discount in the datatable box_2
  public formGroupDetail: FormGroup;
  public formGroupTable: FormGroup;
  public formGroupBoxes: FormGroup;
  public customers_list: ICustomer[] = [];
  public filtered_customers_site_list: any = [];
  public filtered_referents_list: any = [];
  public customers_site_list: ICustomerAddressList[] = [];
  public figures_list: IFigure[] = [];
  public referents_list: ICustomerReferentList[] = [];
  public commercial_list: any = [];
  public isMobile: boolean = false;
  public total_deal: number = 0;
  public total_discounted_deal: number = 0;
  public products_list_datatable: IProductList[] = []; //Contains the selected employees from the detail section
  public tablesRows: ITableRows[] = [];
  public billingFrequencyList: Array<string> = [];
  public dealDocument: any; //Variable for the upload of the document
  public fileName: string = null;
  public completedFileUpload: boolean = false;
  public selectedRowIndex: number = null;
  public columnTable: IColumnTable = {
    //Object for back-end tells which columns to show in the generated document
    product_name: true,
    description: true,
    price: true,
    period: true,
    quantity: true,
    line_amount: true,
    discount: false,
  };
  public toggleModalAdd: boolean = false;
  public showErrors: boolean = false;

  constructor(
    public _formBuilder: FormBuilder,
    public _userService: UserService,
    public _customerService: CustomerService,
    public _utilService: UtilsService,
    public _figureService: UserFigureService,
    private router: Router,
    private _deviceService: DeviceDetectorService,
    public _authService: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private toastService: ToastrService,
    private _listService: ListService,
    public _modalService: NgbModal,
    private _productsService: ProductsService,
    private _productsDealsService: ProductDealsService,
  ) {
    this._utilService.disableAutoHideLoading();
    this.activatedRoute.params.subscribe((params) => {
      this.dealId = params.id;
    });
    this.formGroupDetail = this._formBuilder.group({
      type: new FormControl(null, [Validators.required, Validators.minLength(1), Validators.maxLength(255)]),
      customer: new FormControl(null, [Validators.required]),
      office_site: new FormControl(null, [Validators.required]),
      referent_id: new FormControl(null),
      commercial: new FormControl(null, [Validators.required]),
      name: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
      object: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      product: new FormControl(null, [Validators.required]),
      start_date: new FormControl(null, [Validators.required]),
      end_date: new FormControl(null, [Validators.required]),
      billing_frequency: new FormControl(null, [Validators.required]),
      tranche_number: new FormControl(null, [Validators.required]),
    });
    this.formGroupTable = this._formBuilder.group({
      description: new FormControl(null),
      period: new FormControl(null),
      price: new FormControl(null),
      quantity: new FormControl(1),
      product_name: new FormControl(null),
      product_id: new FormControl([]),
      line_amount: new FormControl(null),
      discount: new FormControl(null),
    });
    this.formGroupBoxes = this._formBuilder.group({
      box_1: new FormControl(null, [Validators.required]),
      box_2: new FormControl(null, [Validators.required]),
      box_3: new FormControl(null, [Validators.required]),
      box_4: new FormControl(null, [Validators.required]),
      box_5: new FormControl(null, [Validators.required]),
      box_6: new FormControl(null, [Validators.required]),
      box_7: new FormControl(null, [Validators.required]),
      box_8: new FormControl(null, [Validators.required]),
    });
    this.isMobile = this._deviceService.isMobile();
  }

  async ngOnInit() {
    if (!this._authService.hasCapability("edit_deal")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.productsList = await this._productsService.getProductsList();
    this.commercial_list = await this._userService.getList("employee", "Direzione,Commerciale");
    this.commercial_list = this.commercial_list.sort((a: any, b: any) => (a.lastname > b.lastname ? 1 : -1));
    this.customers_list = await this._customerService.getCustomers();
    this.customers_list = this.customers_list.sort((a, b) => (a.name > b.name ? 1 : -1));
    this.referents_list = await this._customerService.getReferents();
    this.customers_site_list = await this._customerService.getAddresses();
    this.figures_list = await this._figureService.getList();
    this.billingFrequencyList = await this._listService.getList("billing_frequency");
    await this.loadDeal();
    this._utilService.hideLoading();
  }

  async loadDeal() {
    this.tablesRows = [];
    await this._productsDealsService
      .getDeal(this.dealId)
      .then((response: IDealProductSingle) => {
        this.deal = response;
        //Here we change the referent's list and the site
        this.filtered_referents_list = this.referents_list.filter((r) => r.client_id === this.deal.client.id);
        this.filtered_customers_site_list = this.customers_site_list.filter((s) => s.client.id === this.deal.client.id);
        //Here we push the employees of the deal in the ng-select of the formGroupDetail
        let products: number[] = [];
        this.deal?.products.map((product: IProductList) => {
          products.push(product.id);
        });

        this.formGroupDetail.patchValue({
          type: "Product",
          customer: this.deal?.client.id,
          office_site: this.deal?.client_site.id,
          referent_id: this.deal?.referent.id,
          commercial: this.deal?.commercial.hash,
          product: products,
          object: this.deal?.object,
          name: this.deal?.name,
          start_date: this.deal.start_date ? moment(this.deal?.start_date).format("YYYY-MM-DD") : null,
          end_date: this.deal.end_date ? moment(this.deal?.end_date).format("YYYY-MM-DD") : null,
          billing_frequency: this.deal?.billing_frequency,
          tranche_number: this.deal?.tranche_number,
        });

        this.formGroupBoxes.patchValue({
          box_1:
            this.deal && this.deal.deal_document && this.deal.deal_document.box_1 ? this._utilService.stripHTML(this.deal?.deal_document?.box_1.replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, "\n")).replace(/&#34;/g, '"') : null,
          box_2:
            this.deal && this.deal.deal_document && this.deal.deal_document.box_2 ? this._utilService.stripHTML(this.deal?.deal_document?.box_2.replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, "\n")).replace(/&#34;/g, '"') : null,
          box_3:
            this.deal && this.deal.deal_document && this.deal.deal_document.box_3 ? this._utilService.stripHTML(this.deal?.deal_document?.box_3.replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, "\n")).replace(/&#34;/g, '"') : null,
          box_4:
            this.deal && this.deal.deal_document && this.deal.deal_document.box_4 ? this._utilService.stripHTML(this.deal?.deal_document?.box_4.replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, "\n")).replace(/&#34;/g, '"') : null,
          box_5:
            this.deal && this.deal.deal_document && this.deal.deal_document.box_5 ? this._utilService.stripHTML(this.deal?.deal_document?.box_5.replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, "\n")).replace(/&#34;/g, '"') : null,
          box_6:
            this.deal && this.deal.deal_document && this.deal.deal_document.box_6 ? this._utilService.stripHTML(this.deal?.deal_document?.box_6.replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, "\n")).replace(/&#34;/g, '"') : null,
          box_7:
            this.deal && this.deal.deal_document && this.deal.deal_document.box_7 ? this._utilService.stripHTML(this.deal?.deal_document?.box_7.replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, "\n")).replace(/&#34;/g, '"') : null,
          box_8:
            this.deal && this.deal.deal_document && this.deal.deal_document.box_8 ? this._utilService.stripHTML(this.deal?.deal_document?.box_8.replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, "\n")).replace(/&#34;/g, '"') : null,
        });
        if (this.deal.deal_document.table && this.deal.deal_document.table.length > 0) {
          //check if we have element in row
          //We patch the form groups with the first element in the array also we take which columns to show
          this.formGroupTable.patchValue({
            description: this.deal?.deal_document?.table[0]?.description ? this.deal?.deal_document?.table[0]?.description : null,
            period: this.deal?.deal_document?.table[0]?.period ? this.deal?.deal_document?.table[0]?.period : null,
            price: this.deal?.deal_document?.table[0]?.price ? this.deal?.deal_document?.table[0]?.price : null,
            quantity: this.deal?.deal_document?.table[0]?.quantity ? this.deal?.deal_document?.table[0]?.quantity : null,
            product_name: this.deal?.deal_document?.table[0]?.product_name ? this.deal?.deal_document?.table[0]?.product_name : null,
            product_id: this.deal?.deal_document?.table[0]?.product_id ? this.deal?.deal_document?.table[0]?.product_id : null,
            line_amount: this.deal?.deal_document?.table[0]?.line_amount ? this.deal?.deal_document?.table[0]?.line_amount : null,
            discount: this.deal?.deal_document?.table[0]?.discount ? this.deal?.deal_document?.table[0]?.discount : null,
          });
          if (!!this.deal.deal_document.table_columns) {
            this.columnTable = this.deal?.deal_document?.table_columns;
          }
          this.deal?.deal_document?.table.map((item: ITableRows) => {
            if (item) {
              this.tablesRows.push({
                product_name: item?.product_name,
                product_id: item?.product_id,
                description: item?.description,
                price: item?.price,
                period: item?.period,
                quantity: item?.quantity,
                line_amount: item?.line_amount,
                discount: item?.discount,
              });
            }
          });
        } else {
          //If we don't find any element in row we push a default row
          this.addRow();
        }

        //Here we fill the total
        this.calculateTotalDealAmount();
        //Here we fill the array employee for the datatable ng-select
        this.fillDataTableProductsArray();
        this.contentHeader = {
          headerTitle: "DETAIL_OFFER_PRODUCT",
          actionButton: false,
          breadcrumb: {
            type: "",
            links: [
              {
                name: "Home",
                isLink: true,
                link: "/",
              },
              {
                name: "MENU.DEALS",
                isLink: true,
                link: "/dashboard/deals/list",
              },
              {
                name: "DETAIL_OFFER_PRODUCT",
                isLink: false,
              },
            ],
          },
        };
      })
      .catch((err) => {
        if (err === "Unauthorized") {
          this.router.navigateByUrl("/dashboard/deals/list");
          this._utilService.showToastrError("NOT_AUTHORIZED");
          return false;
        }
      });
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroupDetail.controls[field_name].status === "INVALID";
    } else {
      return this.formGroupDetail.controls[field_name].status === "INVALID" && this.formGroupDetail.controls[field_name].touched;
    }
  }

  async modalOpen(modalBasic, selectedRow: ITableRows, index: number) {
    if (selectedRow) {
      this.formGroupTable.patchValue({
        description: selectedRow.description ? selectedRow.description : null,
        period: selectedRow.period ? selectedRow.period : null,
        price: selectedRow.price ? selectedRow.price : null,
        quantity: selectedRow.quantity ? selectedRow.quantity : null,
        product_name: selectedRow.product_name ? selectedRow.product_name : null,
        product_id: selectedRow.product_id ? selectedRow.product_id : null,
        line_amount: selectedRow.line_amount ? selectedRow.line_amount : null,
        discount: selectedRow.discount ? selectedRow.discount : null,
      });
      this.selectedRowIndex = index;
      this._modalService.open(modalBasic, {
        size: "md",
        centered: true,
        keyboard: false,
        backdrop: false,
      });
    }
  }

  //Function for add a new row in the datatable box_2
  addRow(id_product: number = null) {
    //Here we set the values null but someone we will take from the first element if is present
    this.tablesRows.push({
      description: null,
      period: this.formGroupTable.value.period ? this.formGroupTable.value.period : null,
      price: id_product && !!this.productsList.find((pro) => pro.id === id_product).monthly_amount ? this._utilService.addDotsToNumber(this.productsList.find((pro) => pro.id === id_product).monthly_amount) : null,
      quantity: this.formGroupTable.value.quantity ? this.formGroupTable.value.quantity : null,
      product_name: id_product ? this.productsList.find((pro) => pro.id === id_product).name : null,
      product_id: id_product ? Number(id_product) : null,
      line_amount:
        id_product && !!this.productsList.find((pro) => pro.id === id_product).monthly_amount && this.formGroupTable.value.quantity
          ? this._utilService.addDotsToNumber(Number(this.productsList.find((pro) => pro.id === id_product).monthly_amount) * this.formGroupTable.value.quantity)
          : null,
      discount: null,
    });
  }

  editRow() {
    this.tablesRows[this.selectedRowIndex] = this.formGroupTable.value;
    this.tablesRows[this.selectedRowIndex].product_name = this.productsList.find((pro) => pro.id == this.formGroupTable.value.product_id).name;

    //When save is pressed also we calculate the total Deal Amount
    this.calculateTotalDealAmount();
    this._modalService.dismissAll();
  }

  changeTab(tab: string) {
    this.activeTab = this.activeTab === tab ? "" : tab;
  }

  fillDataTableProductsArray() {
    this.products_list_datatable = this.productsList.filter((pro) => this.formGroupDetail.value.product.includes(pro.id));
    //if this detail section completed it means the product is comeback in detail section
    if (this.isDetailSectionCompleted) {
      this.tablesRows.map((item: ITableRows, index: number) => {
        if (item.product_id && !this.formGroupDetail.value.product.includes(item.product_id)) {
          //If a product it's been removed we show an alert
          if (this.tablesRows.length < 2) {
            this.tablesRows.pop();
          } else {
            this.tablesRows.splice(index, 1);
            this.tablesRows = this.tablesRows.filter((i) => i);
          }
          //recalculate total
          this.calculateTotalDealAmount();
          //Alert product removed
          this.toastService.error(italian.data.ALERT.REMOVED_PRODUCT_PRESENT_DATATABLE, italian.data.ALERT.ALERT_TITLE, {
            toastClass: "toast ngx-toastr",
            closeButton: true,
          });
        }
      });
      //Here we check if a new product it's been added, so we have to push it in the datatable automatically
      if (this.formGroupDetail.value.product && this.formGroupDetail.value.product.length > 0) {
        this.formGroupDetail.value.product.map((item) => {
          const alreadyInDatatable = this.tablesRows.find((row) => row.product_id === item);
          if (!alreadyInDatatable) {
            this.tablesRows.push({
              description: null,
              period: this.formGroupTable.value.period ? this.formGroupTable.value.period : null,
              price: this.formGroupTable.value.price ? this.formGroupTable.value.price : null,
              quantity: this.formGroupTable.value.quantity ? this.formGroupTable.value.quantity : null,
              product_name: item ? this.productsList.find((pro) => pro.id === item).name : null,
              product_id: item ? item : null,
              line_amount: null,
              discount: null,
            });
          }
        });
      }
    }
  }

  formatMoneyValue(value: string, format: string) {
    value = value.trim();
    if (format === "line_amount") {
      if (!!value) {
        this.formGroupTable.patchValue({
          line_amount: this._utilService.addDotsToNumber(value),
        });
      } else {
        this.formGroupTable.patchValue({
          line_amount: null,
        });
      }
    }
    if (format === "discount") {
      if (!!value) {
        this.formGroupTable.patchValue({
          discount: this._utilService.addDotsToNumber(value),
        });
      } else {
        this.formGroupTable.patchValue({
          discount: null,
        });
      }
    }
    if (format === "price") {
      if (!!value) {
        this.formGroupTable.patchValue({
          price: this._utilService.addDotsToNumber(value),
        });
      } else {
        this.formGroupTable.patchValue({
          price: null,
        });
      }
      this.calculateLineAmount(this.formGroupTable.value.price);
    }
  }

  calculateLineAmount(value: string) {
    if (!!value) {
      if (!!this.formGroupTable.value.quantity) {
        const total: number = this._utilService.removeDotsFromNumber(value) * this.formGroupTable.value.quantity;
        this.formGroupTable.patchValue({
          line_amount: this._utilService.addDotsToNumber(total),
        });
        this.tablesRows.map((item) => {
          if (!!item.price && !!item.quantity) {
            const totalItem: number = this._utilService.removeDotsFromNumber(String(item.price)) * item.quantity;
            item.line_amount = this._utilService.addDotsToNumber(totalItem);
          }
        });
      }
    }
    //Recalculate total when line_amount change
    this.calculateTotalDealAmount();
  }

  //This function calculates the month number e the duration for the type task and the period for Time Material type
  async calculateDifferenceInMonth() {
    this.showErrors = false;
    const startDate: moment.Moment = moment(this.formGroupDetail.value.start_date);
    const endDate: moment.Moment = moment(this.formGroupDetail.value.end_date);
    if (this.formGroupDetail.value.start_date && this.formGroupDetail.value.end_date) {
      if (startDate > endDate) {
        this.formGroupDetail.patchValue({
          start_date: null,
          end_date: null,
        });
        this.datePicker.forEach((item: any) => item.clear());
        await this._utilService.showSWALError({ text: "ERROR_DATE" });
        this.showErrors = true;
        return false;
      }
      if (this.tablesRows && this.tablesRows.length > 0) {
        this.tablesRows.map((el: ITableRows) => {
          el.period = moment(this.formGroupDetail.value.start_date).format("MMMYYYY") + " - " + moment(this.formGroupDetail.value.end_date).format("MMMYYYY");
        });
      }
      this.formGroupTable.patchValue({
        period: moment(this.formGroupDetail.value.start_date).format("MMMYYYY") + " - " + moment(this.formGroupDetail.value.end_date).format("MMMYYYY"),
      });
      this.calculateLineAmount(this.formGroupTable.value.price);
      //Calculate default tranche_number is the difference between start_date and end_date
      this.formGroupDetail.patchValue({
        tranche_number: endDate.diff(startDate, "months") === 0 ? 1 : Math.round(endDate.diff(startDate, "months", true)),
      });
      if (!!this.formGroupDetail.value.billing_frequency) {
        const billing: any = this.billingFrequencyList.find((i: any) => i.id === this.formGroupDetail.value.billing_frequency);
        let tranche: number = this.formGroupDetail.value.tranche_number;
        if (!!tranche) {
          this.formGroupDetail.patchValue({
            tranche_number: Math.round(tranche / billing.other.month_value),
          });
        }
      }
    }
  }

  //Here we calculate the total amount e the total discounted
  calculateTotalDealAmount() {
    //When called we reset the values
    this.isThereDiscount = false;
    this.total_deal = 0;
    this.total_discounted_deal = 0;

    this.tablesRows.map((item: ITableRows) => {
      //check if they are not value 0
      if (!!item.price && (item.price == 0 || item.price == "0,00")) {
        item.price = null;
      }
      if (!!item.discount && (item.discount == 0 || item.discount == "0,00")) {
        item.discount = null;
      }

      //Calculate total
      if (item.line_amount) {
        this.total_deal += this._utilService.removeDotsFromNumber(String(item.line_amount));
      }
      //Calculate total discounted
      if (item.discount) {
        this.isThereDiscount = true; //We use this variable for showing the Discounted Amount in the box 2
        this.total_discounted_deal += this._utilService.removeDotsFromNumber(String(item.discount));
      } else {
        //If we don't have the discount in this item, we will calculate the discount amount with the total
        if (item.line_amount) {
          this.total_discounted_deal += this._utilService.removeDotsFromNumber(String(item.line_amount));
        }
      }
    });

    this.total_deal = this._utilService.addDotsToNumber(this.total_deal);
    this.total_discounted_deal = this._utilService.addDotsToNumber(this.total_discounted_deal);
    //Here we set the total only for the first element of the array(The backend will read this object)
    if (this.tablesRows && this.tablesRows.length > 0) {
      this.tablesRows[0].total_deal = this.total_deal;
      this.tablesRows[0].total_discounted_deal = this.total_discounted_deal;
    }
  }

  changeReferentList() {
    this.referents_list = this.referents_list.filter((item): any => {
      return item.client_id === this.formGroupDetail.value.customer;
    });
  }

  async onReferentModalFormEvent(ref: any) {
    if (!this._authService.hasCapability("create_customer_referent")) {
      await this.router.navigateByUrl("dashboard/main");
      return false;
    }
    this.referents_list = await this._customerService.getReferents();
    const newReferent: any = this.referents_list.find((referent: any) => Number(referent.id) === Number(ref.id));
    setTimeout(() => {
      this.formGroupDetail.patchValue({
        customer: newReferent.client_id,
      });
      this.changeReferentList();
      this.formGroupDetail.patchValue({
        referent_id: newReferent.id,
      });
    });
  }

  takeDate(event: any, field: string) {
    if (field === "start_date") {
      this.formGroupDetail.patchValue({
        start_date: event,
      });
    }
    if (field === "end_date") {
      this.formGroupDetail.patchValue({
        end_date: event,
      });
    }
  }

  clearDate() {
    this.datePicker.forEach((item: any) => {
      item.clear();
    });
    this.formGroupDetail.patchValue({
      start_date: null,
      end_date: null,
    });
  }

  async handlerChangeFileInput(event) {
    if (event[0].size > 10000000) {
      await this._utilService.showSWALError({ text: "ERROR_MAX_FILE_SIZE" });
      return false;
    }
    this.fileName = event[0].name;
    this.dealDocument = event;
  }

  async uploadDocument() {
    if (!this._authService.hasCapability("manage_deal_document")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    if (this.dealDocument) {
      this._utilService.showLoading();
      await this._productsDealsService
        .uploadDocument(this.dealDocument[0], this.dealId)
        .then(async () => {
          this.completedFileUpload = true;
          await this.loadDeal();
          await this._utilService.showSWALSuccess({ text: "SUCCESS_UPLOAD_FILE_DOCUMENT" });
        })
        .catch(async () => {
          await this._utilService.showSWALError({ text: "ERROR_UPLOAD_FILE_DOCUMENT" });
        });
    }
  }

  async edit(redirect: boolean = true) {
    this.showErrors = false;
    if (!this._authService.hasCapability("edit_deal")) {
      await this.router.navigateByUrl("/dashboard/main");
      return { error: true };
    }
    let errorLineAmount: boolean = false;
    let errorQuantity: boolean = false;
    let errorPrice: boolean = false;

    //Check date
    const startDate: moment.Moment = moment(this.formGroupDetail.value.start_date);
    const endDate: moment.Moment = moment(this.formGroupDetail.value.end_date);
    if (startDate.format("YYYY-MM-DD HH:mm:00") > endDate.format("YYYY-MM-DD HH:mm:00")) {
      this.activeTab = "deal_detail";
      setTimeout(() => {
        document.getElementById("section2").scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "center",
        });
      });
      await this._utilService.showSWALError({ text: "ERROR_DATE_INSERT" });
      this.showErrors = true;
      return { error: true };
    }
    //Check empty fields
    let keyToShowError: string[] = [];
    Object.keys(this.formGroupDetail.controls).map((key) => {
      if (this.formGroupDetail.controls[key].status === "INVALID") {
        keyToShowError.push(key);
      }
    });

    Object.keys(this.formGroupBoxes.controls).map((key) => {
      if (this.formGroupBoxes.controls[key].status === "INVALID") {
        keyToShowError.push(key);
      }
    });
    if (this.formGroupDetail?.value?.tranche_number == 0) {
      keyToShowError.push("tranche_number");
    }
    if (this.formGroupDetail.invalid || this.formGroupBoxes.invalid || this.formGroupDetail?.value?.tranche_number == 0) {
      let textMessage = await this._utilService.translate("SOME_DATA_ARE_NOT_VALID");
      keyToShowError = await Promise.all(
        keyToShowError.map(async (key) => {
          if (key.includes("box_")) {
            key = key.replace("box_", italian.data.PARAGRAPH + " ");
          }
          key = await this._utilService.translate(key.toUpperCase());
          return key.toLowerCase();
        }),
      );
      textMessage += " " + keyToShowError.join(", ");
      this._utilService.showSWALEmptyField({ text: textMessage });
      return { error: true };
    }
    //we control if line_amount has a value and discount if 0 we send it to null
    this.tablesRows.map(async (row: ITableRows) => {
      if (!row.line_amount) {
        errorLineAmount = true;
      }
      if (!row.quantity) {
        errorQuantity = true;
      }
      if (!row.price || row.price == "0,00") {
        errorPrice = true;
      }
      if (row.discount && (row.discount == "0,00" || row.discount === 0)) {
        row.discount = null;
      }
    });

    if (errorLineAmount) {
      await this._utilService.showSWALError({ text: "ERROR_TOTAL_DEAL" });
      this.showErrors = true;
      return { error: true };
    }
    if (errorQuantity) {
      await this._utilService.showSWALError({ text: "ERROR_QUANTITY" });
      return { error: true };
    }
    if (errorPrice) {
      await this._utilService.showSWALError({ text: "ERROR_PRICE" });
      return { error: true };
    }
    //End Check empty fields

    this._utilService.showLoading();
    let data: IDealProductForm = {
      deal_type: "Product",
      client_id: this.formGroupDetail.value.customer,
      site_id: this.formGroupDetail.value.office_site,
      referent_id: this.formGroupDetail.value.referent_id,
      commercial: this.formGroupDetail.value.commercial,
      object: this.formGroupDetail.value.object,
      name: this.formGroupDetail.value.name,
      products: this.formGroupDetail.value.product,
      start_date: this.formGroupDetail.value.start_date ? this.formGroupDetail.value.start_date : null,
      end_date: this.formGroupDetail.value.end_date ? this.formGroupDetail.value.end_date : null,
      billing_frequency: this.formGroupDetail.value.billing_frequency,
      tranche_number: this.formGroupDetail.value.tranche_number,
      deal_document: {
        box_1: this.formGroupBoxes.value.box_1,
        box_2: this.formGroupBoxes.value.box_2,
        box_3: this.formGroupBoxes.value.box_3,
        box_4: this.formGroupBoxes.value.box_4,
        box_5: this.formGroupBoxes.value.box_5,
        box_6: this.formGroupBoxes.value.box_6,
        box_7: this.formGroupBoxes.value.box_7,
        box_8: this.formGroupBoxes.value.box_8,
        table: JSON.stringify(this.tablesRows.filter((item) => item)),
        table_columns: this.columnTable,
      },
    };
    return this._productsDealsService
      .editDeal(this.dealId, data)
      .then(async () => {
        if (redirect) {
          this._utilService.hideLoading();
          await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_DEAL" });
          await this.router.navigateByUrl("/dashboard/deals/list");
        } else {
          return { error: false };
        }
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_EDIT_DEAL" });
        return { error: true };
      });
  }

  async regenerateDocument() {
    await this._utilService
      .showSWALDeleteConfirmation({
        text: "ALERT.CONFIRM_REGENERATE_TEXT",
        customClass: { confirmButton: "btn btn-success" },
        confirmButtonText: "CONFIRM_GENERATE_BTN",
      })
      .then(async (result) => {
        if (result.value) {
          this.edit(false).then(async (response: { error: boolean }) => {
            if (!response.error) {
              this._utilService.showLoading();
              await this._productsDealsService
                .generateDealDocument(this.dealId)
                .then(async () => {
                  await this.loadDeal();
                  this._utilService.hideLoading();
                  await this._utilService.showSWALSuccess({ text: "SUCCESS_GENERATE_DEAL_DOCUMENT" });
                })
                .catch(async () => {
                  this._utilService.hideLoading();
                  await this._utilService.showSWALError({ text: "ERROR_GENERATE_DEAL_DOCUMENT" });
                });
            }
          });
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_GENERATE_TEXT",
          });
        }
      });
  }

  async generateDocument() {
    this.edit(false).then(async (response: { error: boolean }) => {
      if (!response.error) {
        this._utilService.showLoading();
        await this._productsDealsService
          .generateDealDocument(this.dealId)
          .then(async () => {
            await this.loadDeal();
            this._utilService.hideLoading();
            await this._utilService.showSWALSuccess({ text: "SUCCESS_GENERATE_DEAL_DOCUMENT" });
          })
          .catch(async () => {
            this._utilService.hideLoading();
            await this._utilService.showSWALError({ text: "ERROR_GENERATE_DEAL_DOCUMENT" });
          });
      }
    });
  }

  downloadDocument() {
    return this._utilService.downloadPDF(this.deal.deal_document.document_url, this.deal.complete_name.replace("#", ""));
  }

  resetCustomerInformations(customer: ICustomer) {
    this.formGroupDetail.patchValue({
      referent_id: null,
      office_site: null,
    });

    this.filtered_referents_list = this.referents_list.filter((r) => r.client_id === customer.id);
    this.filtered_customers_site_list = this.customers_site_list.filter((s) => s.client.id === customer.id);
  }
}
